<template>
  <div class="wrapper">
    <h1>试卷分析</h1>
    <div class="actBar">
      <div class="switchSide">
        <div
          @click="analysisSwitch(1)"
          :class="['switchBtn', contentType == 1 ? 'switchingBtn' : '']"
        >
          基本分析
        </div>
        <div
          @click="analysisSwitch(2)"
          :class="['switchBtn', contentType == 2 ? 'switchingBtn' : '']"
        >
          试题分析
        </div>
      </div>
      <div class="btnSide">
        <el-button type="primary" plain size="small" @click="refreshData"
          >更新统计分析</el-button
        >
        <el-button @click="toRecord" type="primary" plain size="small"
          >查看考试记录</el-button
        >
        <el-button type="primary" plain size="small">一键收起</el-button>
        <el-button @click="printContext" type="primary" size="small"
          >导出统计分析(PDF)</el-button
        >
      </div>
    </div>
    <div
      class="basicAnalysisContainer"
      id="basicAnalysisContainer"
      ref="basicAnalysisContainer"
      v-show="contentType == 1"
    >
      <h2>成绩分析</h2>
      <div class="contentBox">
        <div class="title">试卷成绩总结</div>
        <el-table :data="resultTable" border size="small">
          <el-table-column prop="examTotalScore" label="试卷总分">
          </el-table-column>
          <el-table-column prop="examNum" label="考试次数"> </el-table-column>
          <el-table-column prop="averageScore" label="平均分">
          </el-table-column>
          <el-table-column prop="maxScore" label="最高分"> </el-table-column>
          <el-table-column prop="minScore" label="最低分"> </el-table-column>
          <el-table-column
            prop="passScore"
            min-width="120px"
            label="及格分(总分60%)"
          >
          </el-table-column>
          <el-table-column label="及格率">
            <template slot-scope="scope">
              {{ scope.row.passRate + "%" }}</template
            >
          </el-table-column>
          <el-table-column prop="passNum" label="及格次数"> </el-table-column>
        </el-table>
        <br /><br />
        <div class="pieContainer" v-if="initComplete">
          <h2>考试及格率(饼图)</h2>
          <v-chart
            class="chart"
            :option="passRatePie"
            style="height: 400px"
          ></v-chart>
        </div>
      </div>
      <h2>试卷分析</h2>
      <div class="contentBox">
        <!-- <div class="title">分数段统计分析</div>
      <div class="filterBar">自定义分数段：</div>

      <div class="pieContainer">
        <v-chart class="chart" :option="scoreRangePie"></v-chart>
      </div> -->

        <div class="title">分类统计分析</div>
        <el-table :data="groupDTOList" border>
          <el-table-column prop="questionGroupName" label="分类名称">
          </el-table-column>
          <el-table-column prop="totalScore" label="分类试题总分">
          </el-table-column>
          <el-table-column prop="questionNum" label="分类试题数量">
          </el-table-column>
          <el-table-column prop="correctNum" label="答对数量">
          </el-table-column>
          <el-table-column prop="errNum" label="答错数量"> </el-table-column>
          <el-table-column label="正确率">
            <template slot-scope="scope">
              <p>{{ scope.row.correctRate + "%" }}</p></template
            >
          </el-table-column>
        </el-table>
        <br />
        <div class="title">试题分类统计分析(柱状图)</div>
        <div class="pieContainer">
          <v-chart :option="groupStatisticsPie" style="height: 400px"></v-chart>
        </div>
        <br />
        <div class="title">各题型正确率</div>
        <el-table :data="typeDTOList" border>
          <el-table-column prop="questionTypeName" label="题型">
          </el-table-column>
          <el-table-column prop="questionNum" label="题目数"> </el-table-column>
          <el-table-column prop="answerNum" label="总答题次数">
          </el-table-column>
          <el-table-column prop="errNum" label="错误次数"> </el-table-column>
          <el-table-column prop="correctNum" label="正确次数">
          </el-table-column>
          <el-table-column prop="correctRate" label="正确率">
            <template slot-scope="scope">
              {{ scope.row.correctRate + "%" }}</template
            >
          </el-table-column>
          <el-table-column label="错误率">
            <template slot-scope="scope">
              {{ scope.row.errRate + "%" }}</template
            >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="questionAnalysisContainer" v-show="contentType == 2">
      <div class="actBar">
        <div class="switchSide">
          <div
            @click="questionTypeSwitch(false)"
            :class="[
              'switchBtn',
              'smallFont',
              !questionSearchCondition.correctRateOrder ? 'switchingBtn' : '',
            ]"
          >
            错题排行
          </div>
          <div
            @click="questionTypeSwitch(true)"
            :class="[
              'switchBtn',
              'smallFont',
              questionSearchCondition.correctRateOrder ? 'switchingBtn' : '',
            ]"
          >
            对题排行
          </div>
        </div>
      </div>

      <el-pagination
        @current-change="getquestionData"
        :current-page.sync="questionSearchCondition.jumpPage"
        :page-size="questionSearchCondition.pageSize"
        layout="total, prev, pager, next, jumper"
        size="small"
        style="margin: 5px 0"
        :total="questionSearchCondition.total"
      >
      </el-pagination>
      <el-table
        :data="questionData"
        v-show="questionSearchCondition.correctRateOrder"
        border
        size="small"
      >
        <el-table-column width="50">
          <template slot-scope="{ $index }">
            {{
              (questionSearchCondition.jumpPage - 1) *
                questionSearchCondition.pageSize +
              $index +
              1
            }}</template
          >
        </el-table-column>
        <el-table-column
          prop="questionTitle"
          :formatter="removeTag"
          :show-overflow-tooltip="true"
          label="标题"
          min-width="300px"
        >
        </el-table-column>
        <el-table-column prop="groupName" label="分类"> </el-table-column>

        <el-table-column
          prop="correctNum"
          v-show="questionSearchCondition.correctRateOrder"
          label="正确次数"
          width="80px"
        >
        </el-table-column>
        <el-table-column prop="answerNum" label="考试次数" width="80px">
        </el-table-column>

        <el-table-column
          prop="correctRate"
          v-show="questionSearchCondition.correctRateOrder"
          label="正确率"
          width="60px"
        >
          <template slot-scope="scope">
            {{ scope.row.correctRate + "%" }}</template
          >
        </el-table-column>
      </el-table>
      <el-table
        :data="questionData"
        v-show="!questionSearchCondition.correctRateOrder"
        border
        size="small"
      >
        <el-table-column width="50">
          <template slot-scope="{ $index }">
            {{
              (questionSearchCondition.jumpPage - 1) *
                questionSearchCondition.pageSize +
              $index +
              1
            }}</template
          >
        </el-table-column>
        <el-table-column
          prop="questionTitle"
          :formatter="removeTag"
          :show-overflow-tooltip="true"
          label="标题"
          min-width="300px"
        >
        </el-table-column>
        <el-table-column prop="groupName" label="分类"> </el-table-column>
        <el-table-column
          prop="errNum"
          v-show="!questionSearchCondition.correctRateOrder"
          label="错误次数"
          width="80px"
        >
        </el-table-column>
        <el-table-column prop="answerNum" label="考试次数" width="80px">
        </el-table-column>
        <el-table-column
          prop="errRate"
          v-show="!questionSearchCondition.correctRateOrder"
          label="错误率"
          width="80px"
        >
          <template slot-scope="scope"> {{ scope.row.errRate + "%" }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { basicAnalysis, questionAnalysis } from "@/api/analysis.js";
import ECharts from "vue-echarts";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart } from "echarts/charts";
import {
  TooltipComponent,
  TitleComponent,
  LegendComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  TooltipComponent,
  PieChart,
  LegendComponent,
  TitleComponent,
]);

import Print from "print-js";

export default {
  data() {
    return {
      contentType: 1,
      initComplete: false,
      groupDTOList: [],
      typeDTOList: [],
      resultTable: [],
      basicSearchCondition: {
        examId: 0,
        startTime: "",
        endTime: "",
      },
      passRatePie: {
        title: {
          text: "考试及格率",
          //   subtext: "纯属虚构",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {d}%",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["及格率", "不及格率"],
        },
        series: [
          {
            name: "考试及格率",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      groupStatisticsPie: {
        //   title: {
        //   text: "考试及格率",
        //   //   subtext: "纯属虚构",
        //   left: "center",
        // },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            console.log(params);
            return `分类正确率<br>${params.name}:${params.value}`;
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [],
            type: "bar",
            showBackground: true,
            label: {
              show: true,
              formatter: function (params) {
                return `${params.value}%`;
              },
              position: "top",
            },
            color: ["#3398DB"],
          },
        ],
      },
      questionSearchCondition: {
        jumpPage: 1,
        pageSize: 30,
        total: 0,
        examId: 0,
        correctRateOrder: false,
      },
      questionData: [],
    };
  },
  components: {
    "v-chart": ECharts,
  },
  created() {},
  mounted() {
    this.basicSearchCondition.examId = this.$route.query.id;
    this.questionSearchCondition.examId = this.$route.query.id;
    this.getBasicData();
    // this.getquestionData();
  },
  methods: {
    analysisSwitch(type) {
      if (type == this.contentType) {
        return;
      } else {
        this.contentType = type;
        if (type == 1) {
          this.basicSearchCondition.jumpPage = 1;
          this.getBasicData();
        } else if (type == 2) {
          this.questionSearchCondition.jumpPage = 1;
          this.getquestionData();
        }
      }
    },
    questionTypeSwitch(type) {
      if (this.correctRateOrder == type) {
        return;
      } else {
        this.questionSearchCondition.correctRateOrder = type;
        this.questionSearchCondition.jumpPage = 1;
        this.getquestionData();
      }
    },
    refreshData() {
      if (this.contentType == 1) {
        this.getBasicData();
      } else if (this.contentType == 2) {
        this.getquestionData();
      }
    },
    removeTag(row, column, cellValue, index) {
      return row.questionTitle.replace(/<[^>]+>/g, "");
    },
    getBasicData() {
      basicAnalysis(this.basicSearchCondition).then((data) => {
        this.passRatePie.series[0].data = [];
        this.passRatePie.series[0].data.push(
          { name: "及格率", value: data.passRate },
          { name: "不及格率", value: data.noPassRate }
        );
        this.groupStatisticsPie.xAxis.data = [];
        this.groupStatisticsPie.series[0].data = [];
        data.groupDTOList.forEach((item) => {
          this.groupStatisticsPie.xAxis.data.push(item.questionGroupName);
          this.groupStatisticsPie.series[0].data.push(item.correctRate);
        });
        this.groupDTOList = data.groupDTOList;
        this.typeDTOList = data.typeDTOList;
        this.resultTable = [data];
        this.basicSearchCondition.total = data.total;

        // console.log(data);
        this.initComplete = true;
      });
    },
    getquestionData() {
      questionAnalysis(this.questionSearchCondition).then((data) => {
        this.questionSearchCondition.total = data.total;
        this.questionData = data.dtoList;
      });
    },
    printContext() {
      this.contentType = 1;
      setTimeout(() => {
        Print({
          printable: "basicAnalysisContainer",
          type: "html",
          targetStyles: ["*"],
        });
      }, 500);
    },
    toRecord() {
      this.$router.push({
        name: "recordList",
        query: { id: this.basicSearchCondition.examId },
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .actBar {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    height: 48px;
    align-items: center;

    .switchSide {
      display: flex;
      .switchBtn {
        line-height: 48px;
        height: 48px;
        margin-bottom: -1px;
        padding: 0 10px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.6;
        }
      }
      .switchingBtn {
        color: #409eff;
        border-bottom: 3px solid #409eff;
      }
    }

    .btnSide {
    }
  }
  .contentBox {
    padding: 20px;
    background: #fff;
    .title {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-weight: bold;
      line-height: 32px;
      margin-bottom: 8px;
      &:after {
        content: "";
        position: absolute;
        left: -6px;
        top: 4px;
        height: 24px;
        width: 3px;
        background: #409eff;
      }
    }
    .pieContainer {
      border: 1px solid #ccc;
      width: 70%;
      padding: 15px;
      .chart {
        width: 100%;
      }
    }
  }
  .questionAnalysisContainer {
    background: #fff;
    padding: 15px;
    margin: 10px 0;

    .switchingBtn {
      color: #515a6e !important;
      border-bottom: 3px solid #900b09 !important;
    }
  }
}
h2 {
  margin: 5px 0;
}
</style>
